export enum RoleType {
  None = 0,
  SuperAdmin = 1, //Tüm sayfaları görebilir, tüm butonları görebilir, insert, update, delete yapabilir.
  RBHUser = 2, //Admin sayfasını göremez.
  GeneralUser = 3, //Admin sayfasını göremez. Gridlerdeki detail butonu hariç diğer butonları göremez.
  Customer = 4,
}

export const RoleTypeSelectionChoices = [
  { key: RoleType.GeneralUser, value: "General User" },
  { key: RoleType.RBHUser, value: "RBH User" },
  { key: RoleType.SuperAdmin, value: "Super Admin" },
];
